import React from 'react';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { Box } from '@components/Box';
import { Field, Input } from '@components/FormElements';
import { Stack } from '@components/Stack';
import { T } from '../../types';

type SurnameProps = {
  value: string;
  onChange: () => void;
  onBlur: () => void;
  error?: string;
  t: T;
};

export const Surname = ({
  error,
  onChange,
  onBlur,
  value,
  t
}: SurnameProps) => {
  return (
    <Stack spacing="small">
      <Field
        label={t('registerForm.fieldLabel.surname')}
        message={
          error && (
            <Box marginTop="xxsmall">
              <ErrorMessage>{error}</ErrorMessage>
            </Box>
          )
        }
      >
        <Input
          tone={error ? 'danger' : 'neutral'}
          id="account-details-form-surname"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          autoCapitalize="words"
        />
      </Field>
    </Stack>
  );
};
